export default __webpack_public_path__ + "static/media/tick.533bc736.svg";